function makeLookup(array) {
  const lookup = array.reduce((acc, {id, value}) => { acc[id] = value; return acc; }, {});
  return (id => lookup[id] || id);
}

export const commercialityCodeValuesConst = [
  {id: "1", value: "1 - Commercial"},
  {id: "2", value: "2 - U.S. Government Agencies"},
  {id: "3", value: "3 - U.S. Government Contractors"},
  {id: "4", value: "4 - GSA Government Agencies and Contractors"},
  {id: "5", value: "5 - State, Local - Non GSA"},
  {id: "6", value: "6 - State, Local and Education (SLED) - GSA"},
  {id: "7", value: "7 - Education - Non GSA"},
  {id: "A", value: "A - Commercial Sale for End User"},
  {id: "B", value: "B - Commercial Sale for Reseller"},
  {id: "C", value: "C - Commercial Sale for Distributor"},
  {id: "N", value: "N - Not Applicable"},
];

export const globalDealValuesConst = [
  {id: "NA", value: "Non Applicable"},
  {id: "L2L", value: "Local to Local"},
];

export const globalDealValues = [
  {id: "GLB", value: "Global"},
  {id: "MNT", value: "Multinational"},
  {id: "LC", value: "Local"},
];

export const billingFrequencyValuesConst = [
  {id: "ANN", value: "Annually"},
  {id: "MNTH", value: "Monthly"},
  {id: "QTR", value: "Quarterly"},
  {id: "SANN", value: "Semi-Annual"},
];

export const incomingPaymentMethodValuesConst = [
  {id: "A", value: "A - Amex Payment Method"},
  {id: "D", value: "D - Default Payment Method"},
  {id: "M", value: "M - MasterCard Payment Method"},
  {id: "P", value: "P - PayPal Payment Method"},
  {id: "V", value: "V - VISA Payment Method"},
];

export const billingCycleValuesConst = [
  {id: "A01", scope: "ANN", value: "A01 - Bill Cycle Annual start with January"},
  {id: "A02", scope: "ANN", value: "A02 - Bill Cycle Annual start with February"},
  {id: "A03", scope: "ANN", value: "A03 - Bill Cycle Annual start with March"},
  {id: "A04", scope: "ANN", value: "A04 - Bill Cycle Annual start with April"},
  {id: "A05", scope: "ANN", value: "A05 - Bill Cycle Annual start with May"},
  {id: "A06", scope: "ANN", value: "A06 - Bill Cycle Annual start with June"},
  {id: "A07", scope: "ANN", value: "A07 - Bill Cycle Annual start with July"},
  {id: "A08", scope: "ANN", value: "A08 - Bill Cycle Annual start with August"},
  {id: "A09", scope: "ANN", value: "A09 - Bill Cycle Annual start with September"},
  {id: "A10", scope: "ANN", value: "A10 - Bill Cycle Annual start with October"},
  {id: "A11", scope: "ANN", value: "A11 - Bill Cycle Annual start with November"},
  {id: "A12", scope: "ANN", value: "A12 - Bill Cycle Annual start with December"},
  {id: "M01", scope: "MNTH", value: "M01 - Bill Cycle Monthly"},
  {id: "Q01", scope: "QTR", value: "Q01 - Bill Cycle Quarterly start with January"},
  {id: "Q02", scope: "QTR", value: "Q02 - Bill Cycle Quarterly start with February"},
  {id: "Q03", scope: "QTR", value: "Q03 - Bill Cycle Quarterly start with March"},
  {id: "Q04", scope: "QTR", value: "Q04 - Bill Cycle Quarterly start with April"},
  {id: "Q05", scope: "QTR", value: "Q05 - Bill Cycle Quarterly start with May"},
  {id: "Q06", scope: "QTR", value: "Q06 - Bill Cycle Quarterly start with June"},
  {id: "Q07", scope: "QTR", value: "Q07 - Bill Cycle Quarterly start with July"},
  {id: "Q08", scope: "QTR", value: "Q08 - Bill Cycle Quarterly start with August"},
  {id: "Q09", scope: "QTR", value: "Q09 - Bill Cycle Quarterly start with September"},
  {id: "Q10", scope: "QTR", value: "Q10 - Bill Cycle Quarterly start with October"},
  {id: "Q11", scope: "QTR", value: "Q11 - Bill Cycle Quarterly start with November"},
  {id: "Q12", scope: "QTR", value: "Q12 - Bill Cycle Quarterly start with December"},
  {id: "S01", scope: "SANN", value: "S01 - Bill Cycle Semi-Annual start with January"},
  {id: "S02", scope: "SANN", value: "S02 - Bill Cycle Semi-Annual start with February"},
  {id: "S03", scope: "SANN", value: "S03 - Bill Cycle Semi-Annual start with March"},
  {id: "S04", scope: "SANN", value: "S04 - Bill Cycle Semi-Annual start with April"},
  {id: "S05", scope: "SANN", value: "S05 - Bill Cycle Semi-Annual start with May"},
  {id: "S06", scope: "SANN", value: "S06 - Bill Cycle Semi-Annual start with June"},
  {id: "S07", scope: "SANN", value: "S07 - Bill Cycle Semi-Annual start with July"},
  {id: "S08", scope: "SANN", value: "S08 - Bill Cycle Semi-Annual start with August"},
  {id: "S09", scope: "SANN", value: "S09 - Bill Cycle Semi-Annual start with September"},
  {id: "S10", scope: "SANN", value: "S10 - Bill Cycle Semi-Annual start with October"},
  {id: "S11", scope: "SANN", value: "S11 - Bill Cycle Semi-Annual start with November"},
  {id: "S12", scope: "SANN", value: "S12 - Bill Cycle Semi-Annual start with December"},
];

export const contractAccountBillingCycleValuesConst = [
  {id: "SH01", scope: "MNTH", value: "SH01 - Bill Cycle + 1st day"},
  {id: "SH02", scope: "MNTH", value: "SH02 - Bill Cycle + 2nd day"},
  {id: "SH03", scope: "MNTH", value: "SH03 - Bill Cycle + 3rd day"},
  {id: "SH04", scope: "MNTH", value: "SH04 - Bill Cycle + 4th day"},
  {id: "SH05", scope: "MNTH", value: "SH05 - Bill Cycle + 5th day"},
  {id: "SH06", scope: "MNTH", value: "SH06 - Bill Cycle + 6th day"},
  {id: "SH07", scope: "MNTH", value: "SH07 - Bill Cycle + 7th day"},
  {id: "SH08", scope: "MNTH", value: "SH08 - Bill Cycle + 8th day"},
  {id: "SH09", scope: "MNTH", value: "SH09 - Bill Cycle + 9th day"},
  {id: "SH10", scope: "MNTH", value: "SH10 - Bill Cycle + 10th day"},
  {id: "SH11", scope: "MNTH", value: "SH11 - Bill Cycle + 11th day"},
  {id: "SH12", scope: "MNTH", value: "SH12 - Bill Cycle + 12th day"},
  {id: "SH13", scope: "MNTH", value: "SH13 - Bill Cycle + 13th day"},
  {id: "SH14", scope: "MNTH", value: "SH14 - Bill Cycle + 14th day"},
  {id: "SH15", scope: "MNTH", value: "SH15 - Bill Cycle + 15th day"},
  {id: "SH30", scope: "MNTH", value: "SH30 - Bill Cycle + 30th day"},
];

export const CONTRACT_ACCOUNT_BILLING_CYCLE_IDS = Object.freeze({
  SH01: "SH01",
  SH02: "SH02",
  SH03: "SH03",
  SH04: "SH04",
  SH05: "SH05",
  SH06: "SH06",
  SH07: "SH07",
  SH08: "SH08",
  SH09: "SH09",
  SH10: "SH10",
  SH11: "SH11",
  SH12: "SH12",
  SH13: "SH13",
  SH14: "SH14",
  SH15: "SH15",
  SH30: "SH30",
});

const allowedInvoiceSchedulingIds = {
  SH01: true,
  SH02: true,
  SH03: true,
  SH04: true,
  SH05: true,
  SH06: true,
  SH07: true,
  SH08: true,
  SH09: true,
  SH10: true,
  SH13: true,
  SH30: true,
};
export const invoiceSchedulingValuesConst =
  contractAccountBillingCycleValuesConst.filter(it => allowedInvoiceSchedulingIds[it.id]);
export const invoiceSchedulingLookupConst = makeLookup(billingCycleValuesConst);

export const accountDeterminationIdOptionsConst = [
  {id: "MP", value: "Managed Service Partner"},
  {id: "MS", value: "Managed Service Customer"},
];
export const accountDeterminationIdLookupConst = makeLookup(accountDeterminationIdOptionsConst);

export const correspondenceVariantOptionsConst = [
  {id: "Z001", value: "Z001 - HP Invoice (summary + MID Level)"},
  {id: "Z002", value: "Z002 - HP Invoice (summary + Detailed)"},
  {id: "Z003", value: "Z003 - HP Invoice (summary)"},
];
export const correspondenceVariantLookupConst = makeLookup(correspondenceVariantOptionsConst);

export const contractAccountCategoryOptionsConst = [
  {id: "X1", value: "X1 - HP Managed Services Customer BA", defaultAccDeterminationIdTo: "MS"},
  {id: "X2", value: "X2 - HP Managed Partner Vendor BA", defaultAccDeterminationIdTo: "MP"},
];
export const contractAccountCategoryLookupConst = makeLookup(contractAccountCategoryOptionsConst);

export const contractAccountPaymentTermOptionsConst = [
  {id: "2D2M", value: "2D2M - 2nd day 2nd month"},
  {id: "ADVP", value: "ADVP - Cash In Advance"},
  {id: "EM02", value: "EM02 - 60 days end of month"},
  {id: "EM30", value: "EM30 - 30 days end of month"},
  {id: "EM60", value: "EM60 - 60 days end of month"},
  {id: "EM90", value: "EM90 - 90 days end of month"},
  {id: "FS01", value: "FS01 - FI-CA Extended"},
  {id: "GI45", value: "GI45 - HP Services Global Invoicing45"},
  {id: "GI60", value: "GI60 - HP Services Global Invoicing60"},
  {id: "GI90", value: "GI90 - HP Services Global Invoicing90"},
  {id: "GIPT", value: "GIPT - Within 30 days due net-Gl Inv"},
  {id: "N120", value: "N120 - Within 120 days due net"},
  {id: "NT00", value: "NT00 - Payable immediately due net"},
  {id: "NT05", value: "NT05 - Within 5 days Due net"},
  {id: "NT10", value: "NT10 - Within 10 days Due net"},
  {id: "NT14", value: "NT14 - Within 14 days due net"},
  {id: "NT15", value: "NT15 - Within 15 days due net"},
  {id: "NT30", value: "NT30 - Within 30 days due net"},
  {id: "NT35", value: "NT35 - Within 35 days due net"},
  {id: "NT37", value: "NT37 - Within 37 days due net"},
  {id: "NT40", value: "NT40 - Within 40 days due net"},
  {id: "NT42", value: "NT42 - Within 42 days due net"},
  {id: "NT45", value: "NT45 - Within 45 days due net"},
  {id: "NT50", value: "NT50 - Within 50 days due net"},
  {id: "NT60", value: "NT60 - Within 60 days due net"},
  {id: "NT62", value: "NT62 - Within 62 days due net"},
  {id: "NT65", value: "NT65 - Within 65 days Due net"},
  {id: "NT75", value: "NT75 - Within 75 days due net"},
  {id: "NT90", value: "NT90 - Within 90 days due net"},
  {id: "NT93", value: "NT93 - Within 93 Days due net"},
  {id: "SPV6", value: "SPV6 - NET 30 DAYS GOV"},
  {id: "ZCPA", value: "ZCPA - Charged to American Express Cd"},
  {id: "ZCPB", value: "ZCPB - Charged to Mastercard"},
  {id: "ZCPC", value: "ZCPC - Charged to Visacard"},
  {id: "ZCPD", value: "ZCPD - Charged to Discover Card"},
  {id: "ZCPF", value: "ZCPF - PayPal payable immediately due net - ZPAL HP PayPal"},
  {id: "ZCSO", value: "ZCSO - Credit Card Generic Term"},
  {id: "ZCPH", value: "ZCPH - Discover card Immediately due"}
];

export const paymentTermOptionsConst = [
  {id: "2D2M", value: "2D2M - 2nd day 2nd month"},
  {id: "ADVP", value: "ADVP - Cash In Advance"},
  {id: "EM02", value: "EM02 - Due net - 2nd of next month"},
  {id: "EM20", value: "EM20 - Due net - 20th of next month"},
  {id: "EM30", value: "EM30 - 30 days end of month"},
  {id: "EM60", value: "EM60 - 60 days end of month"},
  {id: "EM90", value: "EM90 - 90 days end of month"},
  {id: "FS01", value: "FS01 - FI-CA Extended"},
  {id: "GI45", value: "GI45 - HP Services Global Invoicing45"},
  {id: "GI60", value: "GI60 - HP Services Global Invoicing60"},
  {id: "GI90", value: "GI90 - HP Services Global Invoicing90"},
  {id: "GIPT", value: "GIPT - Within 30 days due net-Gl Inv"},
  {id: "N120", value: "N120 - Within 120 days due net"},
  {id: "NT00", value: "NT00 - Payable immediately due net"},
  {id: "NT05", value: "NT05 - Within 5 days Due net"},
  {id: "NT10", value: "NT10 - Within 10 days Due net"},
  {id: "NT14", value: "NT14 - Within 14 days due net"},
  {id: "NT15", value: "NT15 - Within 15 days due net"},
  {id: "NT30", value: "NT30 - Within 30 days due net"},
  {id: "NT35", value: "NT35 - Within 35 days due net"},
  {id: "NT37", value: "NT37 - Within 37 days due net"},
  {id: "NT40", value: "NT40 - Within 40 days due net"},
  {id: "NT42", value: "NT42 - Within 42 days due net"},
  {id: "NT45", value: "NT45 - Within 45 days due net"},
  {id: "NT50", value: "NT50 - Within 50 days due net"},
  {id: "NT60", value: "NT60 - Within 60 days due net"},
  {id: "NT62", value: "NT62 - Within 62 days due net"},
  {id: "NT65", value: "NT65 - Within 65 days Due net"},
  {id: "NT75", value: "NT75 - Within 75 days due net"},
  {id: "NT90", value: "NT90 - Within 90 days due net"},
  {id: "NT93", value: "NT93 - Within 93 Days due net"},
  {id: "SPV6", value: "SPV6 - NET 30 DAYS GOV"},
  {id: "ZCPA", value: "ZCPA - Charged to American Express Cd"},
  {id: "ZCPB", value: "ZCPB - Charged to Mastercard"},
  {id: "ZCPC", value: "ZCPC - Charged to Visacard"},
  {id: "ZCPD", value: "ZCPD - Charged to Discover Card"},
  {id: "ZCPF", value: "ZCPF - PayPal payable immediately due net - ZPAL HP PayPal"},
  {id: "ZCSO", value: "ZCSO - Credit Card Generic Term"},
  {id: "ZCPH", value: "ZCPH - Discover card Immediately due"}
];
export const paymentTermLookupConst = makeLookup(paymentTermOptionsConst);

export const matlBusinessCodeOptionsConst = [
  {id: "F10D", value: "TABLET - F10D"},
  {id: "F145", value: "DESKTOP, LOW END - F145"},
  {id: "F161", value: "COMMERCIAL NOTEBOOKS - F161"},
  {id: "F17U", value: "OFFSITE OR EXCHNG CONS TABLET - F17U"},
  {id: "F18F", value: "DESKTOP, HIGHEND - F18F"},
  {id: "F18Y", value: "THINCLIENTS - F18Y"},
  {id: "F19D", value: "WORKSTATION - B,C,J - F19D"},
  {id: "F19E", value: "WORKSTATION - 300,400,700 - F19E"},
  {id: "F19T", value: "WORKSTATION - IA64 HIGH - F19T"},
  {id: "F19X", value: "WORKSTATION - IA64 LOW - F19X"},
  {id: "F1B9", value: "BLADE PC'S - F1B9"},
  {id: "F1E1", value: "APPLE iPHONE AND iPAD - F1E1"},
  {id: "F1E2", value: "NX90XX BUSINESS NOTEBOOKS - F1E2"},
  {id: "F1E3", value: "PAVILION/PRESARIO NOTEBOOK PCS - F1E3"},
  {id: "F1E4", value: "PAVILION/PRESARIO DESKTOP PCS - F1E4"},
  {id: "F1GE", value: "MICROSOFT WORKSTATION PRODUCTS - F1GE"},
  {id: "F1JG", value: "RETAIL POINT OF SALE - F1JG"},
  {id: "F1N9", value: "BUSINESS NOTEBOOKS - LOW END - F1N9"},
  {id: "F1W0", value: "OFFSITE ONLY webOS TABLET - F1W0"},
  {id: "F1XS", value: "WORKSTATION - F1XS"},
  {id: "F1ZR", value: "COMMERCIAL IMMERSIVE UNITS - F1ZR"},
  {id: "F1ZU", value: "MOBILITY RETAIL POINT OF SALE - F1ZU"},
  {id: "F25T", value: "OP SYS, UNIX - F25T"},
  {id: "F29W", value: "OP SYS, LINUX (PSG) - F29W"},
  {id: "F29Y", value: "OP SYS, MICROSOFT (PSG) - F29Y"},
  {id: "F2AA", value: "RHEL WS SW TECHNICAL SUPPORT - F2AA"},
  {id: "F2C9", value: "PSG SW APPS, STANDARD (RGS) - F2C9"},
  {id: "F2HH", value: "HP HANDHELD SW - F2HH"},
  {id: "F2JC", value: "OP SYS, HP-UX ITANIUM WKSTN - F2JC"},
  {id: "F2SG", value: "OP SYS, HPUX OES PA-RSC WRKSTN - F2SG"},
  {id: "F2Z7", value: "SW APPS, WORKSTATION PSG - F2Z7"},
  {id: "F3M9", value: "MONITORS & ACCESORIES - F3M9"},
  {id: "F4C8", value: "PSG OOW CONS SUPP DT/NB PCs - F4C8"},
  {id: "F8MP", value: "DO NOT USE - INVALID BUS CODE - F8MP"},
  {id: "H0CD", value: "CUSTOM DELIVERABLES - H0CD"},
  {id: "H0CP", value: "CUSTOM PRICING - H0CP"},
  {id: "H0CR", value: "STANDALONE CREDITS - H0CR"},
  {id: "H0IS", value: "MISCELLANEOUS CUSTOM - H0IS"},
  {id: "H0NP", value: "SUMMARIZED PRICING - H0NP"},
  {id: "H0NQ", value: "RETURN TO SUPPORT - H0NQ"},
  {id: "H0PA", value: "PRICE ADJUSTMENTS - H0PA"},
  {id: "H0SU", value: "SUPPORT UPGRADES - H0SU"},
  {id: "H12X", value: "HW SUPPORT - H12X"},
  {id: "H24X", value: "SW SUPPORT - H24X"},
  {id: "H3WF", value: "WFM ONLY - NOT SUPPORTED - H3WF"},
  {id: "H52Y", value: "RELOCATION SUPPORT - H52Y"},
  {id: "H563", value: "INSTALLATION, STARTUP, & IMPLE - H563"},
  {id: "H5Q4", value: "INSTALLATION, STARTUP & IMPLEM - H5Q4"},
  {id: "H5Q7", value: "INSTALLATION, STARTUP & IMPLM - H5Q7"},
  {id: "H73J", value: "AVAILABILITY PARTNERSHIP SUPPO - H73J"},
  {id: "H73N", value: "RESOURCE SERVICES SUPPORT - H73N"},
  {id: "H73W", value: "OPERATIONS SERVICES SUPPORT - H73W"},
  {id: "H744", value: "CONSULTING SERVICES - H744"},
  {id: "H747", value: "STANDALONE SERVICES, EDUCATION - H747"},
  {id: "H74H", value: "DEVELOPER SUPPORT - H74H"},
  {id: "H74W", value: "HW/SW COMBINATION SUPPORT - H74W"},
  {id: "H75X", value: "OPEN ENVIRONMENT SUPPORT - H75X"},
  {id: "H7MS", value: "RECYCLING SERVICE - H7MS"},
  {id: "H7MT", value: "MT - KITS - H7MT"},
  {id: "H7S3", value: "HP SW MANAGED SERVICES - H7S3"},
  {id: "H7SV", value: "HP SW PROFESSIONAL SERVICES - H7SV"},
  {id: "L21X", value: "CUSTOMER SERVICES SW ALLIANCES - L21X"},
  {id: "L2AE", value: "SW, STORAGE - LEGATO - L2AE"},
  {id: "L851", value: "MULTIVENDOR NON-NETWORK - L851"},
  {id: "L90S", value: "LCL, 9X5, ALL RESP TIMES - L90S"},
  {id: "L91A", value: "LCL, 9X5, ND - L91A"},
  {id: "L91B", value: "LCL, 9X5,13H,16H, DAY6; ND 4HR - L91B"},
  {id: "L91D", value: "LCL,ALL SERV WIN,ND,4HR, 6CTR - L91D"},
  {id: "L91E", value: "LCL, 13H, 16H, DAY6; 4HR - L91E"},
  {id: "L91F", value: "LCL, 13H, 16H, DAY6, 24X7; 4HR - L91F"},
  {id: "L91S", value: "LCL, 24X7; 4HR - L91S"},
  {id: "L91T", value: "LCL, 24X7; 6CTR - L91T"},
  {id: "L91U", value: "LCL, STS 9X5 - L91U"},
  {id: "L91W", value: "LCL, STS 24X7 - L91W"},
  {id: "L91Y", value: "LCL, STS 9X5, 13H, 16H, DAY6 - L91Y"},
  {id: "L92A", value: "LCL PRODUCTS BRAND DESKTOP - L92A"},
  {id: "L92B", value: "LCL PROD NONBRAND DESKTOP - L92B"},
  {id: "L93A", value: "LCL PRODUCTS BRAND LAPTOP - L93A"},
  {id: "L93B", value: "LCL PROD NONBRAND LAPTOP - L93B"},
  {id: "L93C", value: "LCL PRODUCTS BRAND SERVER - L93C"},
  {id: "L93D", value: "LCL PROD NONBRAND SERVER - L93D"},
  {id: "L94S", value: "LCL, 9X5, 4 HR - L94S"},
  {id: "L94Z", value: "LCL, ALL SERV WINDOWS; 4HR - L94Z"},
  {id: "L95A", value: "LCL PROD BRAND SW - L95A"},
  {id: "L95C", value: "LCL PRODUCTS BRAND STORAGE - L95C"},
  {id: "L96A", value: "LCL PROD BRAND LOW END PRINTER - L96A"},
  {id: "L96B", value: "LCL PROD NONBRAND LO END PRINT - L96B"},
  {id: "L96D", value: "LCL NONBRAND HIGH END PRINT - L96D"},
  {id: "L97A", value: "LCL PROD BRAND PERIPHERALS - L97A"},
  {id: "L97B", value: "LCL PROD NONBRAND PERIPHS - L97B"},
  {id: "L97C", value: "LCL PROD BRAND HIGH END PRINT - L97C"},
  {id: "L97D", value: "LCL PROD NONBRAND STORAGE - L97D"},
  {id: "L98A", value: "LCL PRODUCTS BRAND UPS - L98A"},
  {id: "L98B", value: "LCL PRODUCTS NONBRAND UPS - L98B"},
  {id: "L99A", value: "LCL PRODUCTS BRAND NETWORK - L99A"},
  {id: "L99B", value: "LCL PROD NONBRAND NETWORK - L99B"},
  {id: "L9J2", value: "JW ORACLE/BEA - L9J2"},
  {id: "L9JP", value: "LCL PRODUCTS, DISCOUNTABLE - L9JP"},
  {id: "L9LH", value: "LCL PRODUCTS - L9LH"},
  {id: "L9RS", value: "LCL, STS 9X5; REMOTE ONLY - L9RS"},
  {id: "L9RZ", value: "LCL,NO LIMIT RESPNS;RMOTE ONLY - L9RZ"},
  {id: "L9US", value: "LCL, 9X5, ND, 4HR - L9US"},
  {id: "L9UY", value: "LCL MULTIVEN, PROD, EXCHNG SVC - L9UY"},
  {id: "L9UZ", value: "LCL, ALL SERV WINDOWS, ND, 4HR - L9UZ"},
  {id: "P103", value: "PERSONAL LASERJET - MONO - P103"},
  {id: "P107", value: "LOW-END BUSINESS MONO LASER - P107"},
  {id: "P108", value: "DIG SENDERS/HIGH END SCANJETS - P108"},
  {id: "P109", value: "BUSINESS COLOR LASER - P109"},
  {id: "P10F", value: "NETWORK PERIPHERAL SOLUTIONS - P10F"},
  {id: "P111", value: "LINE IMPACT - P111"},
  {id: "P112", value: "LOW-MID COMMERCIAL INKJET - P112"},
  {id: "P117", value: "LOW-END WIDE FORMAT - P117"},
  {id: "P11A", value: "PERSONAL LASER MFP & SCANJETS - P11A"},
  {id: "P11B", value: "PERSONAL LASERJET - COLOR - P11B"},
  {id: "P11D", value: "COPIER-BASED MFPS - P11D"},
  {id: "P11E", value: "MID-RANGE BUSINESS MONO LASER - P11E"},
  {id: "P11F", value: "HIGH-END BUS MONO LASER/MFP - P11F"},
  {id: "P11J", value: "HIGH-END PAGE-LIMIT PRINT /MFP - P11J"},
  {id: "P11K", value: "HIGH-END BUS/OFFICE INKJET - P11K"},
  {id: "P11L", value: "MID-RANGE WIDE FORMAT - P11L"},
  {id: "P11M", value: "HIGH-END WIDE FORMAT - P11M"},
  {id: "P137", value: "HAND-HELD MFP PRINTERS - P137"},
  {id: "P138", value: "PERSONAL LASER, NON-REPAIRABLE - P138"},
  {id: "P17Q", value: "PWP - P17Q"},
  {id: "P1H8", value: "EDGELINE TECHNOLOGY HIGH END - P1H8"},
  {id: "P1H9", value: "EDGELINE TECHNOLOGY - P1H9"},
  {id: "P1IO", value: "INDIGO - P1IO"},
  {id: "P1KQ", value: "HIGH-END BUS COLOR LASER/MFP - P1KQ"},
  {id: "P1LS", value: "LF PRODUCTION HW HIGH VOLUME - P1LS"},
  {id: "P1RP", value: "RETAIL PHOTO SOLUTIONS - P1RP"},
  {id: "P1YX", value: "LF Industrial - P1YX"},
  {id: "P1YZ", value: "Graphics Textiles - P1YZ"},
  {id: "P1ZB", value: "LF Production HW Low Volume - P1ZB"},
  {id: "P1ZD", value: "HP Graphics PWI Packaging - P1ZD"},
  {id: "P1ZF", value: "S-Print Copier - P1ZF"},
  {id: "P1ZH", value: "S-Print Mix Service - P1ZH"},
  {id: "P1ZN", value: "S-Print OffSite - P1ZN"},
  {id: "P1ZO", value: "S-Print OnSite - P1ZO"},
  {id: "P1ZQ", value: "A3 CONTRACTUAL LASER - P1ZQ"},
  {id: "P1ZX", value: "GRAPHICS PAGE WIDE - P1ZX"},
  {id: "P1ZY", value: "JET FUSION 3D - P1ZY"},
  {id: "P206", value: "OUTPUT MANAGEMENT SW - P206"},
  {id: "P2DC", value: "DOC CAPTURE&SECURITY SOLUTIONS - P2DC"},
  {id: "P2LG", value: "DOCUMENT CAPTURE SW - P2LG"},
  {id: "P2RQ", value: "RETAIL PHOTO SOLUTIONS SW - P2RQ"},
  {id: "P2WJ", value: "WEB JET ADMIN SERVICES - P2WJ"},
  {id: "P2XT", value: "EXSTREAM SW - P2XT"},
  {id: "P313", value: "IPG ACCESSORIES - P313"},
  {id: "P314", value: "IPG SUPPLIES - P314"},
  {id: "P415", value: "DESKJET PRINTERS - P415"},
  {id: "P416", value: "OFFICEJETS/OTHER MFPS - P416"},
  {id: "P418", value: "PHOTOSMART PRINTERS - P418"},
  {id: "P419", value: "PHOTOSMART CAMERAS - P419"},
  {id: "P4C3", value: "IPG OOW CONS SUPP LEVEL 1 - P4C3"},
  {id: "P4C4", value: "IPG OOW CONS SUPP LEVEL 2 - P4C4"},
  {id: "P4C6", value: "IPG OOW CONS SUPP LEVEL 3 - P4C6"},
  {id: "P4C7", value: "IPG OOW CONS SUPP PROJECTORS - P4C7"},
  {id: "P4D8", value: "DOCUMENT-CENTRIC SCANNERS - P4D8"},
  {id: "P4E5", value: "DVD/CD WRITERS - P4E5"},
  {id: "P4E6", value: "BIP PRINTERS - P4E6"},
  {id: "P4Z2", value: "DIGITAL PROJECTORS - P4Z2"},
  {id: "P4Z3", value: "SCANJET SCANNERS - P4Z3"},
  {id: "P7HZ", value: "IPG TRAINING COURSES - P7HZ"},
];

export const productCategoryOptionsConst = [
  {id: "F", value: "Compute - F"},
  {id: "H", value: "Service Specific - H"},
  {id: "L", value: "Local & Multivendor - L"},
  {id: "P", value: "Print - P"},
];

export const dorMultiPoTypeOptionsConst = [
  {id: "S", value: "S - Customer issues a single purchase order"},
  {id: "A", value: "A - Customer issues an annual purchase order"},
  {id: "N", value: "N - Non Multi-year"},
];

export const dorRenewalOptionsConst = [
  {id: "X", value: "X - Renewal"},
  {id: "M", value: "M - Migration"},
  {id: "O", value: "O - Other"},
];

export const dorLegacyDocumentType = [
  {id: "NONE", value: "NONE"},
  {id: "ZCRN", value: "ZCRN"},
  {id: "ZDCB", value: "ZDCB"},
];

export const invoiceDistribuitionMethodConst = [
  {id: "EM1", value: "e-invoicing - Pagero"},
  {id: "EM2", value: "e-invoicing - Tungsten"},
  {id: "EM3", value: "e-invoicing - Mebitech"},
  {id: "EM4", value: "e-invoicing - Taxcom"},
  {id: "EM5", value: "e-invoicing - Impact"},
  {id: "EM9", value: "e-invoicing - Tungsten (AU, NZ, SG, HK, MY)"},
  {id: "IDOC", value: "e-invoicing - China & Taiwan"},
  {id: "LM1", value: "e-Invoicing - Interfactura"},
  {id: "LM2", value: "e-Invoicing - Sovos"},
  {id: "MAIL", value: "email"},
  {id: "MPDL", value: "Email PDL"},
  {id: "PM1", value: "Paper - Kohlhammer"},
  {id: "PM2", value: "Paper - Local Printer Wipro"},
  {id: "PM3", value: "Paper - Local Printer"},
  {id: "SPOL", value: "e-invoicing - India"},
];

export const INVOICE_DISTRIBUTION_METHOD_IDS = Object.freeze({
  EM1: "EM1",
  EM2: "EM2",
  EM3: "EM3",
  EM4: "EM4",
  EM5: "EM5",
  EM9: "EM9",
  IDOC: "IDOC",
  MAIL: "MAIL",
  MPDL: "MPDL",
  PM1: "PM1",
  PM2: "PM2",
  PM3: "PM3",
  SPOL: "SPOL",
});

export const CONTRACT_ACCOUNT_PAYMENT_TERM_OPTIONS_IDS = Object.freeze({
  "2D2M": "2D2M",
  ADVP: "ADVP",
  EM02: "EM02",
  EM30: "EM30",
  EM60: "EM60",
  GI45: "GI45",
  GI60: "GI60",
  GI90: "GI90",
  GIPT: "GIPT",
  N120: "N120",
  NT00: "NT00",
  NT05: "NT05",
  NT10: "NT10",
  NT15: "NT15",
  NT30: "NT30",
  NT35: "NT35",
  NT37: "NT37",
  NT40: "NT40",
  NT42: "NT42",
  NT45: "NT45",
  NT50: "NT50",
  NT60: "NT60",
  NT62: "NT62",
  NT65: "NT65",
  NT75: "NT75",
  NT90: "NT90",
  ZCPA: "ZCPA",
  ZCPB: "ZCPB",
  ZCPC: "ZCPC",
  ZCPD: "ZCPD",
  ZCPF: "ZCPF",
  ZCSO: "ZCSO",
});

export const CORRESPONDANCE_VARIAN_IDS = Object.freeze({
  Z001: "Z001",
  Z002: "Z002",
  Z003: "Z003",
});

export const INCOMING_PAYMENT_METHOD_IDS = Object.freeze({
  A: "A",
  D: "D",
  M: "M",
  P: "P",
  V: "V",
});

export const CONTRACT_ACCOUNT_CATEGORIES_IDS = Object.freeze({
  X1: "X1",
  X2: "X2",
});

export const ACCOUNT_DETERMINATION_IDS = Object.freeze({
  MP: "MP",
  MS: "MS",
});

export const acquisitionMethod = Object.freeze([
  {value: "", label: "None"},
  {value: "IB (Install Base)", label: "Customer Owned"},
  {value: "purchase", label: "Customer Purchase"},
  {value: "Direct lease purchase", label: "Direct Lease (Purchase)"},
  {value: "Direct lease", label: "Direct Lease"},
  {value: "Embedded leaseback customer", label: "Embedded Leaseback (Recent Customer Purchase)"},
  {value: "Embedded leaseback", label: "Embedded Leaseback"},
  {value: "Embedded lease purchase", label: "Embedded Lease (Purchase)"},
  {value: "lease", label: "Embedded Lease"},
  {value: "loan", label: "Loan/Demo"},
  {value: "rental", label: "Rental"},
  {value: "Unknown Purchase", label: "Unknown (Purchase)"},
]);

export const dartPurchaseOption = Object.freeze({
  "Installed Base": "IB (Install Base)",
  "Direct Purchase": "purchase",
  "Utility Warehouse": "rental",
  "Embedded Lease": "Embedded lease purchase",
  "Sale Lease Back": "Embedded leaseback",
  "Direct Lease": "Direct lease",
  "": "",
  "Lease To Own": "",
  "Standalone Accessory": "",
  Subscription: "",
  "mai": "IB (Install Base)",
  "new": "purchase"
});

export const invoiceLanguageValuesConst = [
  {id: "AF", value: "Afrikaans"},
  {id: "AR", value: "Arabic"},
  {id: "BG", value: "Bulgarian"},
  {id: "CA", value: "Catalan"},
  {id: "CS", value: "Czech"},
  {id: "DA", value: "Danish"},
  {id: "DE", value: "German"},
  {id: "EL", value: "Greek"},
  {id: "EN", value: "English"},
  {id: "ES", value: "Spanish"},
  {id: "FR", value: "French"},
  {id: "HE", value: "Hebrew"},
  {id: "HI", value: "Hindi"},
  {id: "HR", value: "Croatian"},
  {id: "HU", value: "Hungarian"},
  {id: "ID", value: "Indonesian"},
  {id: "IS", value: "Icelandic"},
  {id: "IT", value: "Italian"},
  {id: "JA", value: "Japanese"},
  {id: "KK", value: "Kazakh"},
  {id: "KO", value: "Korean"},
  {id: "LT", value: "Lithuanian"},
  {id: "LV", value: "Latvian"},
  {id: "MS", value: "Malay"},
  {id: "NL", value: "Dutch"},
  {id: "NO", value: "Norwegian"},
  {id: "PL", value: "Polish"},
  {id: "PT", value: "Portuguese"},
  {id: "RO", value: "Romanian"},
  {id: "RU", value: "Russian"},
  {id: "SH", value: "Serbian (Latin)"},
  {id: "SK", value: "Slovak"},
  {id: "SL", value: "Slovenian"},
  {id: "SR", value: "Serbian"},
  {id: "SV", value: "Swedish"},
  {id: "TH", value: "Thai"},
  {id: "TR", value: "Turkish"},
  {id: "UK", value: "Ukrainian"},
  {id: "VI", value: "Vietnamese"},
  {id: "Z1", value: "Customer reserve"},
  {id: "Z2", value: "English for Indi"},
  {id: "ZF", value: "Chinese trad."},
  {id: "ZH", value: "Chinese"},
  {id: "FI", value: "Finnish"},
  {id: "SE", value: "SE"},
  {id: "ET", value: "Estonian"},
  {id: "SK", value: "Slovakian"},
  {id: "SL", value: "Slovenia"},
  {id: "ZH", value: "Traditional Chinese"},
  {id: "FIL", value: "Filipino"},
  {id: "AR", value: "Egyptian"},
  {id: "ID", value: "Bahasa"}
];
export const CONTRACT_ACCOUNT_ERROR_MESSAGES = Object.freeze({
  PENDINGCA: `There are 1 or more Contract Accounts in pending state. Approve or Reject them before going to next step.`,
  CREATECA: `Please create at least one contract account.`,
  MAPPINGCA: `Please select at least one contract account.`,
});

export const exchangeRateTypeConst=["Standard","Monthly"];